module.exports = __webpack_public_path__ + "img/erosion_grey_al.050558db.svg";